<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type mgr_5">
					<select v-model="outstanding_yn" class="tbl_select sm_int">
						<option value="Y">Outstadning Only</option>
						<option value="N">Show All Purchase Order</option>
					</select>
				</span>
				<em class="lt_text">PO Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="po_date_from"/> ~ <CustomDatePicker v-model="po_date_to"/></span>

				<span class="int_type_no_border mgr_5"> <PartnerSelect v-model="vendor_code" ph="Vendor" :showName="false" :initialName="vendor_name" :nameWidth="200" @set-partner="setPartner" /> </span>

				<span class="int_type sm_int mgr_5">
					<input type="text" v-model.trim="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<table class="list_tbl" v-columns-resizable>
			<thead>
				<tr>
					<th width="100px;">PO No</th>
					<th width="90px;">PO Date</th>
					<th width="120px;">Vendor Code</th>
					<th width="300px;">Vendor Name</th>
					<th width="120px;">Payment Term</th>
					<th width="120px;">Past Due Date</th>
					<th width="70px;">Shipped</th>
					<th width="70px;">Closed</th>
					<th width="70px;">Hold</th>
					<th width="90px;">Total Amt.</th>
					<th width="90px;">Balance</th>
					<th width="30px;"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
					<th width="100px;">Pay Amt.</th>
					<th>Remark</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="p in pos" v-bind:key="p.po_no">
					<td class="al_left truncate">
						<a href="javascript:;" @click="selectPurchase(p)">{{ p.po_dn }} </a>
					</td>
					<td class="al_left">{{ p.po_date }}</td>
					<td class="al_left truncate">
						<a href="javascript:;" @click="gotoPartner(p.vendor_code)">{{ p.vendor_code }}</a>
					</td>
					<td class="al_left truncate" :title="p.vendor_name">{{ p.vendor_name }}</td>
					<td class="al_left truncate" :title="p.payment_term_name">{{ p.payment_term_name }}</td>
					<td class="al_right">{{ p.past_due_date | commaSeparated }}</td>
					<td class="al_center">
						<font color="blue">{{ p.total_shipped_quantity > 0 ? (p.total_quantity == p.total_shipped_quantity ? 'All' : 'Partially') : '' }}</font>
					</td>
					<td class="al_center">{{ p.closed_yn == 'Y' ? 'Closed' : 'Active' }}</td>
					<td class="al_center">{{ p.po_hold_type_code }}</td>
					<td class="al_right">{{ p.total_amount | toCurrency }}</td>
					<td class="al_right">{{ p.balance | toCurrency }}</td>
					<td class="al_center"><input type="checkbox" v-model="p.selected" :disabled="p.balance == 0" @change="selectCheckBox(p)" /></td>
					<td class="al_right">
						<currency-input type="text" v-model.trim="p.pay_amount" :disabled="p.balance == 0" :precision="2" class="r_int long_type al_right" @input="inputPayAmount(p)" @focus="$event.target.select()" />
					</td>
					<td class="al_left">
						{{ p.remark }}
					</td>
				</tr>
				<tr>
					<td colspan="12" class="al_right">
						Paid Amount: <currency-input type="text" v-model.trim="paid_amount" style="width:6em;" :precision="2" class="r_int long_type al_right" @blur="blurPaidAmount()" @input="inputPaidAmount()" />,
						<font color="red">Pay Amount Sum</font>
					</td>

					<td class="al_right">
						<currency-input type="text" v-model.trim="pay_amount_sum" :disabled="true" :precision="2" class="r_int long_type al_right" readonly />
					</td>
					<td colspan="1"></td>
				</tr>
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging v-show="paging_yn == 'Y'" ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box">
			<ul>
				<li><a href="javascript:;" class="gray_bt mgr_15" @click="excel()">Excel</a></li>
				<li><a href="javascript:;" class="gray_bt mgr_15" @click="gotoApHistory()">AP History</a></li>

				<li v-if="modifiable"><a href="javascript:;" class="gray_bt" @click="processPayment()">Process Payment</a></li>
			</ul>
		</div>

		<Modal @close="closeModal" v-if="showModal" :draggable="false">
			<template slot="title">Process Payment</template>
			<template slot="body">
				<PaymentPopup :toPaymentPOs="toPaymentPOs" :totalPayAmount="pay_amount_sum" v-on:close="closeModal()" @payment-call-back="paymentCallBack" />
			</template>
		</Modal>
	</div>
</template>

<script>
//import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectApList } from '@/api/payment/index.js';
//import { apiWaiveInvoice } from '@/api/sales/invoice.js';
//import { defaultDataType } from 'export-xlsx';
//import { exportDataExcel } from '@/api/util';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
//import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import { daysAgo } from '@/utils/date.js';
import PaymentPopup from '@/components/common/PaymentPopup';
import Modal from '@/components/common/Modal';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			po_date_from: null,
			po_date_to: null,
			vendor_code: null,
			vendor_name: null,
			outstanding_yn: 'Y',

			keyword: null,

			allSelected: false,

			pos: [],
			toPaymentPOs: [],
			paid_amount: null,
			pay_amount_sum: null,

			modalName: '',
			showModal: false,

			elapsed_days: null,
			saveParam: {},
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		selectedPOs: function() {
			return this.pos.filter(p => p.selected);
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	components: {
		CustomDatePicker,
		Paging,
		//CodeSelect,
		PartnerSelect,
		PaymentPopup,
		Modal,
	},
	methods: {
		async gotoApHistory() {
			// var partner_name = null;
			// if (this.bill_to_code) partner_name = this.bill_to_name;
			// let routeData = this.$router.resolve({ name: 'arHistory', query: { backUri: this.uri, bill_to_code: this.bill_to_code, bill_to_name: partner_name } });
			// window.open(routeData.href, 'herp_ar_history');
		},
		processPayment() {
			var vm = this;
			this.toPaymentPOs = [];
			this.pos.forEach(function(p) {
				if (p.selected) {
					vm.toPaymentPOs.push(p);
				}
			});
			//console.log(this.toReceiveInvoices);
			if (this.toPaymentPOs.length == 0) {
				this.$toast.error('Nothing to process');
				return;
			}
			//console.log('received amount', this.received_amount);

			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		paymentCallBack(result) {
			if (result) this.selectAps();
		},
		calPayAmount() {
			var vm = this;
			this.pay_amount_sum = 0;
			this.pos.forEach(function(p) {
				if (p.selected) {
					//console.log(invoice.pay_amount);
					vm.pay_amount_sum += p.pay_amount;
				}
			});
		},
		selectCheckBox(p) {
			//console.log(invoice.selected, invoice.balance);
			if (p.selected) p.pay_amount = p.balance;
			else p.pay_amount = null;

			this.calPayAmount();
		},
		inputPayAmount(p) {
			if (p.pay_amount || p.pay_amount === 0) p.selected = true;
			else p.selected = false;

			this.calPayAmount();
		},
		inputPaidAmount() {
			if (this.selectedPOs.length == 0) {
				this.$toast.warning('No selected items. Check PO(s) first.');
				return;
			} //console.log('received amount', this.received_amount);

			var remaining_amount = this.paid_amount;

			this.selectedPOs.forEach(function(p) {
				if (remaining_amount > 0) {
					if (remaining_amount > p.balance) p.pay_amount = p.balance;
					else p.pay_amount = remaining_amount;
					remaining_amount -= p.balance;
				} else {
					p.pay_amount = null;
				}
			});
			this.calPayAmount();
		},
		blurPaidAmount() {
			this.pos.forEach(function(p) {
				//console.log(invoice.pay_amount);
				if (p.pay_amount) {
					//console.log('1');
					p.selected = true;
				} else {
					//console.log('2');
					p.selected = false;
				}
			});
		},
		selectAll() {
			//console.log(this.allSelected);
			var vm = this;
			this.pos.forEach(function(p) {
				if (p.balance) {
					p.selected = vm.allSelected;
					vm.selectCheckBox(p);
				}
			});
		},
		selectPurchase(p) {
			let routeData = this.$router.resolve({ name: 'purchaseDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, po_no: p.po_no } });
			window.open(routeData.href, 'herp_purchase');
			//console.log(p);
			// if (invoice.invoice_type == 'B') this.$router.push({ name: 'arCheck', params: {}, query: { bill_to_code: invoice.bill_to_code, check_no: invoice.bounce_invoice_info } });
			// else if (invoice.invoice_type == 'A') return;
			// else this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
		},

		setPartner(partner) {
			this.vendor_name = partner.name;
			this.search();
		},
		reset() {
			this.po_date_from = this.user.company_id === 'minkhair' ? null : daysAgo(365);
			this.po_date_to = null;
			this.vendor_code = null;
			this.keyword = null;
			// this.elapsed_days = null;
		},
		// async excel() {
		// 	if (this.invoices.length < 1) {
		// 		this.$toast.error('No Data to Export.');
		// 		return false;
		// 	}

		// 	let { data } = await apiSelectArList(this.saveParam);
		// 	let invoices = data.arList;

		// 	invoices.forEach(inv => {
		// 		if (inv.elapsed_days < 31) inv.elapsed_period = 'Under 30 Days';
		// 		else if (inv.elapsed_days < 61) inv.elapsed_period = '31 - 60 Days';
		// 		else if (inv.elapsed_days < 91) inv.elapsed_period = '61 - 90 Days';
		// 		else if (inv.elapsed_days < 121) inv.elapsed_period = '91 - 120 Days';
		// 		else if (inv.elapsed_days < 151) inv.elapsed_period = '121 - 150 Days';
		// 		else if (inv.elapsed_days < 181) inv.elapsed_period = '151 - 180 Days';
		// 		else inv.elapsed_period = 'Over 180 Days';

		// 		let remark = inv.bounce_invoice_info || '';
		// 		if (inv.invoice_type === 'A') remark += inv.remark;
		// 		else if (inv.invoice_type === 'B') remark += '/' + inv.remark;
		// 		inv.remark = remark;
		// 	});

		// 	const fileName = 'AR_DETAIL';
		// 	const headers = [
		// 		{ key: 'invoice_dn', name: 'Inv. No', width: 15, dataType: defaultDataType.string },
		// 		{ key: 'invoice_type', name: 'Type', width: 5, dataType: defaultDataType.string },
		// 		{ key: 'invoice_date', name: 'Inv. Date', width: 15, dataType: defaultDataType.string },
		// 		{ key: 'so_dn', name: 'S/O No', width: 15, dataType: defaultDataType.string },
		// 		{ key: 'so_date', name: 'S/O Date', width: 15, dataType: defaultDataType.string },
		// 		{ key: 'bill_to_code', name: 'Bill To Code', width: 15, dataType: defaultDataType.string },
		// 		{ key: 'bill_to_name', name: 'Bill To Name', width: 15, dataType: defaultDataType.string },
		// 		{ key: 'ship_to_state', name: 'Ship To State', width: 15, dataType: defaultDataType.string },
		// 		{ key: 'sales_group_name', name: 'Sales Group', width: 15, dataType: defaultDataType.string },
		// 		{ key: 'payment_term_code', name: 'Payment Term', width: 15, dataType: defaultDataType.string },
		// 		{ key: 'past_due_date', name: 'Past Due Date', width: 15, dataType: defaultDataType.currency },
		// 		{ key: 'invoice_amount', name: 'Inv. Amt.', width: 15, dataType: defaultDataType.number },
		// 		{ key: 'balance', name: 'Balance', width: 15, dataType: defaultDataType.number },
		// 		{ key: 'elapsed_period', name: 'Elapsed Days', width: 15, dataType: defaultDataType.string },
		// 		{ key: 'remark', name: 'Info.(Bounce, SC & etc.)', width: 30, dataType: defaultDataType.string },
		// 	];

		// 	exportDataExcel(invoices, headers, fileName);
		// },
		search() {
			this.page_no = 1;
			this.selectAps();
		},
		async selectAps() {
			this.allSelected = false;
			this.paid_amount = null;
			this.pay_amount_sum = null;

			if (this.vendor_code) this.paging_yn = 'N';
			else this.paging_yn = 'Y';

			let param = {
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				po_date_from: this.po_date_from,
				po_date_to: this.po_date_to,
				vendor_code: this.vendor_code,

				outstanding_yn: this.outstanding_yn,
				keyword: this.keyword,

				sort_key: 'po_date',
				sort_direction: 'ASC',

				elapsed_days: this.elapsed_days,
			};

			this.saveParam = {
				paging_yn: 'N',

				po_date_from: param.po_date_from,
				po_date_to: param.po_date_to,
				vendor_code: param.vendor_code,
				outstanding_yn: param.outstanding_yn,

				keyword: param.keyword,

				sort_key: param.sort_key,
				sort_direction: param.sort_direction,

				elapsed_days: param.elapsed_days,
			};

			const { data } = await apiSelectApList(param);
			//console.log(data);
			this.pos = data.apList;
			//console.log(this.pos);
			this.list_count = data.list_count;
			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/payment/ap_main?page_no=' + this.page_no;
			if (this.outstanding_yn) uri += '&outstanding_yn=' + this.outstanding_yn;
			if (this.po_date_from) uri += '&po_date_from=' + this.po_date_from;
			if (this.po_date_to) uri += '&po_date_to=' + this.po_date_to;
			if (this.vendor_code) uri += '&vendor_code=' + this.vendor_code;
			if (this.keyword) uri += '&keyword=' + this.keyword;

			this.uri = uri;
			window.history.pushState({}, null, uri);
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectAps();
		},
		gotoPartner(code) {
			this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.uri, code: code } });
		},
		async index() {
			const { data } = await apiIndex();
			console.log(data);
		},
		async init() {
			this.reset();
			//await this.index();

			if (this.$route.query.outstanding_yn) this.outstanding_yn = this.$route.query.outstanding_yn;
			if (this.$route.query.po_date_from) this.po_date_from = this.$route.query.po_date_from;
			if (this.$route.query.po_date_to) this.po_date_to = this.$route.query.po_date_to;
			if (this.$route.query.vendor_code) this.vendor_code = this.$route.query.vendor_code;
			if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			if (this.$route.query.page_no) this.page_no = this.$route.query.page_no;

			await this.selectAps(this.$route.query.page_no);
		},
	},
	created() {
		this.$store.commit('setSideIndex', 4);
		this.$store.commit('setSelectedMenu', 'nav_li_ap_main');
		this.$store.commit('setSubTitle', 'Accounting -> Accounts Payable');

		this.init();
	},
};
</script>

<style></style>
